<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      :beforeOpen="beforeOpen"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-document-copy"
          @click="loadDefaultTemplate"
        >载入默认配置</el-button>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { getList, add, update, remove, getDetail, getDefaultConfig } from './api'
import { rulesInput } from '@/basic-common/util/common'

const DEFAULT_TENANT_ID = '622550'

export default {
  name: 'EmergencyPlanScreenTemplate',
  mixins: [crudMixins],
  data() {
    return {
      form: {},
      apiConfig: {
        getList,
        add: this.addTemplate,
        update: this.updateTemplate,
        remove,
        getDetail,
      },
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        viewBtn: true,
        selection: false,
        dialogWidth: '72%',
        column: [
          {
            label: '租户ID',
            prop: 'tenantId',
            search: false,
            width: 110,
            value: DEFAULT_TENANT_ID,
            maxlength: 12,
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            label: '模板编码',
            prop: 'templateCode',
            search: true,
            minWidth: 180,
            maxlength: 64,
            rules: rulesInput(1),
          },
          {
            label: '模板名称',
            prop: 'templateName',
            search: true,
            minWidth: 220,
            maxlength: 100,
            rules: rulesInput(1),
          },
          {
            label: '默认模板',
            prop: 'isDefault',
            type: 'select',
            search: true,
            width: 110,
            value: 0,
            dicData: [
              { label: '否', value: 0 },
              { label: '是', value: 1 },
            ],
          },
          {
            label: '状态',
            prop: 'status',
            type: 'select',
            search: true,
            width: 100,
            value: 1,
            dicData: [
              { label: '停用', value: 0 },
              { label: '启用', value: 1 },
            ],
          },
          {
            label: '配置JSON',
            prop: 'configJson',
            type: 'textarea',
            span: 24,
            minRows: 18,
            hide: true,
            overHidden: true,
            rules: [
              { required: true, message: '请输入配置JSON', trigger: 'blur' },
              { validator: this.validateJson, trigger: 'blur' },
            ],
          },
          {
            label: '创建时间',
            prop: 'createTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '修改时间',
            prop: 'updateTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 180,
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
        ],
      },
      defaultParams: {},
    }
  },
  methods: {
    beforeOpen(done, type) {
      this.openType = type
      if (type === 'add') {
        this.ensureDefaultConfig().finally(done)
        return
      }
      if (['edit', 'view'].includes(type) && this.apiConfig.getDetail) {
        this.apiConfig.getDetail(this.form.id).then(res => {
          this.form = res.data.data || res.data
          done()
        })
        return
      }
      done()
    },
    addTemplate(row) {
      return add(this.normalizeRow(row))
    },
    updateTemplate(row) {
      return update(this.normalizeRow(row))
    },
    validateJson(rule, value, callback) {
      try {
        JSON.parse(value)
        callback()
      } catch (e) {
        callback(new Error('配置JSON格式不正确'))
      }
    },
    normalizeRow(row) {
      return {
        ...row,
        tenantId: row.tenantId || DEFAULT_TENANT_ID,
        configJson: this.prettyJson(row.configJson),
      }
    },
    prettyJson(value) {
      if (!value) return value
      try {
        return JSON.stringify(JSON.parse(value), null, 2)
      } catch (e) {
        return value
      }
    },
    async ensureDefaultConfig() {
      if (this.form.configJson) return
      const res = await getDefaultConfig()
      const config = res.data.data || res.data || {}
      this.$set(this.form, 'tenantId', this.form.tenantId || DEFAULT_TENANT_ID)
      this.$set(this.form, 'templateCode', this.form.templateCode || 'NX_COAL_RESERVE_SCREEN_V1')
      this.$set(this.form, 'templateName', this.form.templateName || '宁夏煤炭储备应急预案大屏默认模板')
      this.$set(this.form, 'isDefault', this.form.isDefault == null ? 1 : this.form.isDefault)
      this.$set(this.form, 'status', this.form.status == null ? 1 : this.form.status)
      this.$set(this.form, 'configJson', JSON.stringify(config, null, 2))
    },
    async loadDefaultTemplate() {
      try {
        const res = await getDefaultConfig()
        const config = res.data.data || res.data || {}
        this.form = {
          tenantId: DEFAULT_TENANT_ID,
          templateCode: 'NX_COAL_RESERVE_SCREEN_V1',
          templateName: '宁夏煤炭储备应急预案大屏默认模板',
          isDefault: 1,
          status: 1,
          configJson: JSON.stringify(config, null, 2),
        }
        this.$refs.crud.rowAdd()
      } catch (e) {
        console.warn(e)
        this.$message.error('载入默认配置失败')
      }
    },
  },
}
</script>
